import Collections from 'modules/website/components/Collections/Collections'
import React from 'react'

export default function ColectionsView() {
  return (
    <Collections/>
  )
}
